angular.module('pe4h').controller('ResourcesCtrl', function($scope, $state, $timeout, $location, $anchorScroll) {
  function init() {
    var location = $state.params.section;
    
    if (location) {
      $location.hash(location);
      $anchorScroll();
    }
  }

  //init();
  $timeout(function() {
    init();
  }, 100);
});
